export interface PlayItem {
  id: string;
  type: string;
  skillId: string;
  prompt: string;
  options?: string[];
  tiles?: string[];
  ipa?: string;
  hint?: string;
  word?: string;
  words?: string[];
  pictures?: string[];
  scene?: string;
  audio?: string;
  multiSelect?: boolean;
  unscored?: boolean;
  slotCount?: number;
  trainerSlug?: string;
}

export interface ItemAnswerKey {
  correct?: string | string[] | Record<string, string>;
  correctSet?: string[];
  accepted_positions?: string[];
  accepted_answer_sets?: string[];
}

export interface PlayResult {
  correct: boolean | null;
  feedback: string;
  unscored?: boolean;
}

export const POSITION_LABEL: Record<string, string> = {
  start: "Начало",
  middle: "Середина",
  end: "Конец",
  whole_word: "Весь звук — всё слово",
};

export function stepKey(slug: string): string {
  return `clever:lastStep:${slug}`;
}

export function readLastStep(slug: string): { sessionId: string; index: number } | null {
  try {
    const raw = localStorage.getItem(stepKey(slug));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { sessionId: string; index: number };
    if (!parsed.sessionId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeLastStep(slug: string, sessionId: string, index: number): void {
  localStorage.setItem(stepKey(slug), JSON.stringify({ sessionId, index }));
}

export function clearLastStep(slug: string): void {
  localStorage.removeItem(stepKey(slug));
}
